import type { Tealium } from 'src/types/appState';

import { EVENT_VIEW_MULTI_LOCATION } from '../constants';
export const eventName = EVENT_VIEW_MULTI_LOCATION;

export default (tealium: Tealium) => {
  const {
    addOnAdProductNames,
    salaryRangeSelected,
    roleTitle,
    cajaFlowType,
    cajaPayType,
    cajaWorkType,
    jobAdClassification,
    jobAdSubClassification,
    jobAdTypeSelected,
    productSetId,
    productSetProductIds,
    seekAdvertiserId,
    sourceJobId,
  } = tealium;
  return {
    jobId: sourceJobId,
    adSalaryRangeSelected: salaryRangeSelected,
    jobTitle: roleTitle,
    cajaFlowType,
    jobSalaryType: cajaPayType,
    jobWorkType: cajaWorkType,
    jobClassification: jobAdClassification,
    jobSubClassification: jobAdSubClassification,
    adProductName: [jobAdTypeSelected],
    addOnAdProductNames,
    adProductSetId: productSetId,
    productSetProductIds,
    seekAdvertiserId,
  };
};
